export default function BrandIconsNew() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="33" height="32" viewBox="0 0 33 32" fill="none">
      <g id="Happy">
        <path
          id="Vector"
          d="M16.5 32C12.226 32 8.20804 30.336 5.18602 27.314C2.16461 24.292 0.5 20.274 0.5 16C0.5 11.726 2.164 7.70804 5.18602 4.68602C8.20804 1.664 12.226 0 16.5 0C20.774 0 24.792 1.664 27.814 4.68602C30.836 7.70804 32.5 11.726 32.5 16C32.5 20.274 30.836 24.292 27.814 27.314C24.792 30.336 20.774 32 16.5 32ZM16.5 1.52381C12.6332 1.52381 8.99798 3.02933 6.26366 5.76366C3.52933 8.49798 2.02381 12.1332 2.02381 16C2.02381 19.8668 3.52933 23.502 6.26366 26.2363C8.99798 28.9707 12.6332 30.4762 16.5 30.4762C20.3668 30.4762 24.002 28.9707 26.7363 26.2363C29.4707 23.502 30.9762 19.8668 30.9762 16C30.9762 12.1332 29.4707 8.49798 26.7363 5.76366C24.002 3.02933 20.3668 1.52381 16.5 1.52381Z"
          fill="#1F2123"
        />
        <path
          id="Vector_2"
          d="M16.5007 24.4131C14.3521 24.4131 12.2035 23.6061 10.5298 21.9914L9.9812 21.4624L11.0387 20.3652L11.5873 20.8943C14.3423 23.5512 18.659 23.5512 21.414 20.8943L21.9626 20.3652L23.0201 21.4624L22.4716 21.9914C20.7972 23.6055 18.6492 24.4131 16.5007 24.4131Z"
          fill="#1F2123"
        />
        <path id="Vector_3" d="M12.9086 9.79541H11.3848V14.5844H12.9086V9.79541Z" fill="#1F2123" />
        <path id="Vector_4" d="M21.6151 9.79541H20.0913V14.5844H21.6151V9.79541Z" fill="#1F2123" />
      </g>
    </svg>
  );
}
